import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { validaSoloNumero } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoAllCuentasContables from "../../catalogos/catalogoAllCuentasContables";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, SearchInput, Select } from "../../ui/inputs/Input";

export const CerrarConsiliacion = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const cmbMes = useRef();
  const cmbAniio = useRef();
  const txtId2 = useRef();
  const txtCuenta = useRef();
  const cnbConciliado = useRef();
  const [cmbAnio, setCmbAnio] = useState(false);
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdPlan = useRef();
  const txtDatos = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);
  const [cuenta, setCuenta] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState("visible");
  const [values, setValues] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  let token = localStorage.getItem("jwtToken");
  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId2.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe seleccionar una cuenta",
        icono: "informacion",
      });
      sigue = false;
      txtId2.current.focus();
    }
    if (sigue) {
      actualizarSaldo();
    }
  };
  const validarCuentaB = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      } else {
      }
    }
  };

  const cerrarModal = () => {
    props.setShow(false);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const actualizarSaldo = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/cerrarmes`;
    let body;
    setActivate(true);
    body = {
      operacion: parseInt(props.tabla) === 13 ? 1 : 0,
      nmes: cmbMes.current.value,
      nanio: cmbAniio.current.value,
      cmodulo: "CONTABILIDAD",
      idcuenta: visible === "visible" ? parseInt(txtId2.current.value) : 0,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "la conciliación fue cerrada.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const salir = () => {
    props.setShow(false);
  };

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }

  const seleccionarRegistroTipReten = (id) => {
    setMostrar(false);

    let campos = "*";
    let nomtab = "plancuenta";
    let nomid = "idplancuenta";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${idefiscal}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0].cargable) {
            console.log(response.data);
            setCuenta(response.data[0].codigocuenta);
            txtIdPlan.current.value = response.data[0].idplancuenta;
            txtDatos.current.value =
              maskIt("00-000-00-00-000", response.data[0].codigocuenta) +
              "  /  " +
              response.data[0].descripcion.trim();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "LA CUENTA NO ES MOVIMIENTO",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (values) => {
    seleccionarRegistroTipReten(values.idplancuenta);
  };

  const seleccionarCuentaBancaria = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtId2.current.value = response.data.idcuentabancaria;
            txtCuenta.current.value =
              response.data.nombre.trim() +
              " --- " +
              response.data.cuentabancaria.trim();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onChange = (event) => {
    if (event.target.name === "conciliacion") {
      if (parseInt(event.target.value) === 0) {
        setVisible("visible");
      } else {
        setVisible("hidden");
      }
    } else if (event.target.name === "unidad") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipo") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoasiento") {
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const validarCatalogo = (values) => {
    setCatalogoCuenta(false);
    seleccionarCuentaBancaria(values.idcuentabancaria);
  };

  useEffect(() => {
    const anioactu = JSON.parse(localStorage.getItem("anioactu"));
    const anios = [];
    for (let i = 0; i < 7; i++) {
      let anioa = parseInt(anioactu) - i;
      anios.push({
        anio: anioa,
      });
    }
    setCmbAnio(anios);
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">
          {parseInt(props.tabla) === 13
            ? "Cerrar Mes Conciliado."
            : "Abrir Mes Conciliado."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0 d-flex flex-wrap">
          <div className="col-4 m-0 mb-2 p-0 pr-2">
            <Select
              name="conciliacion"
              id="tipo"
              onChange={onChange}
              ref={cnbConciliado}
            >
              <option value="0">Mes Conciliación</option>
              <option value="1">Mes Asientos</option>
            </Select>
          </div>
          <div className="col-4 m-0 mb-2 p-0 pr-2">
            <Select label = 'Mes:'
              name="tipo"
              id="tipo"
              onChange={onChange}
              ref={cmbMes}
            >
              <option value="1">ENERO</option>
              <option value="2">FEBRERO</option>
              <option value="3">MARZO</option>
              <option value="4">ABRIL</option>
              <option value="5">MAYO</option>
              <option value="6">JUNIO</option>
              <option value="7">JULIO</option>
              <option value="8">AGOSTO</option>
              <option value="9">SEPTIEMBRE</option>
              <option value="10">OCTUBRE</option>
              <option value="11">NOVIEMBRE</option>
              <option value="12">DICIEMBRE</option>
            </Select>
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Select label = 'Año:'
              name="tipo"
              id="tipo"
              onChange={onChange}
              ref={cmbAniio}
            >
              {cmbAnio &&
                cmbAnio.map((a) => (
                  <option key={a.anio} value={a.anio}>
                    {a.anio}
                  </option>
                ))}
            </Select>
          </div>
          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded" style={{ visibility: visible }}>
            <legend className="float-none w-auto m-0">
              Datos de la Cuenta Bancaria
            </legend>
            <div className="col-4 m-0 p-0">
              <SearchInput label = 'Código:'
                ref={txtId2}
                name="idasiento"
                onChange={onChange}
                onKeyUp={validarCuentaB}
                onBlur={validarCuentaB}
                onClickButton={() => { setCatalogoCuenta(true) }}
              />
            </div>
            <Input
                name="idasiento"
                disabled
                onChange={onChange}
                ref={txtCuenta}
            />
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
          ref={btnAcepta}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          onClick={salir}
          ref={btnCancela}
        >
            Salir
        </DangerButton>
      </Modal.Footer>
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={validarCatalogo}
      />
      <CatalogoAllCuentasContables
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={validarCuenta}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
